import { CardExpiryElement } from '@stripe/react-stripe-js';
import { FormattedMessage, useIntl } from 'react-intl';

import { DebitCardFieldWrapper } from '../../DebitCardFieldWrapper';
import { stripeElementStyles } from '../../ElementStyles';

export const ExpiryDateField = ({
    error,
    onChange,
    className,
    placeholder
}: {
    error: boolean | null;
    onChange: (response: any) => void;
    className?: string;
    placeholder?: string;
}) => {
    const intl = useIntl();

    const errorMessage = intl.formatMessage({
        id: '_.link_debit_card.expiry_date_error',
        defaultMessage: 'Invalid expiry date'
    });

    return (
        <DebitCardFieldWrapper
            label={
                <FormattedMessage
                    id="_.link_debit_card.expiry_date"
                    defaultMessage="Expiry date"
                />
            }
            error={error ? errorMessage : null}
            className={className}
        >
            <CardExpiryElement
                onChange={onChange}
                options={{ style: stripeElementStyles, placeholder }}
            />
        </DebitCardFieldWrapper>
    );
};
